import { authController } from '@reedexpo/authorization-component-ui';
import { createRemoteJWKSet, jwtVerify } from 'jose';
import { Claims } from '../Constants';

const authCookieName = 'RX_AUTH';
const clientIdCookieName = 'ClientId';

let cachedJWKS = null;
let cachedJwksUrl = null;

const getJwksUrl = () => {
  const authority = window && window.authSettings && window.authSettings.authority;
  return `${authority}/.well-known/openid-configuration/jwks`;
};

const getJWKS = () => {
  const jwksUrl = getJwksUrl();
  if (cachedJWKS && cachedJwksUrl === jwksUrl) {
    return cachedJWKS;
  }
  cachedJwksUrl = jwksUrl;
  cachedJWKS = createRemoteJWKSet(new URL(jwksUrl));
  return cachedJWKS;
};

const verifyToken = async (token) => {
  const JWKS = getJWKS();
  const { payload } = await jwtVerify(token, JWKS);
  return payload;
};

const usePkce = () => (typeof (window) === 'undefined'
  ? false
  : (window && window.authSettings && window.authSettings.usePkce));

const getCookies = () => {
  const cookies = {};
  if (typeof (window) === 'undefined') {
    return {};
  }
  document.cookie.split('; ').forEach((cookie) => {
    const [name, value] = cookie.split('=');
    cookies[name] = decodeURIComponent(value);
  });
  return cookies;
};

const getToken = () => {
  if (usePkce()) {
    return authController.getToken()
      .then((t) => t)
      .catch(() => null);
  }
  return Promise.resolve(getCookies()[authCookieName] || null);
};

const hasClaim = async (allowAdmins, claimName, claimValue) => {
  if (usePkce()) {
    const hasClaimValue = await authController.hasClaim(allowAdmins, claimName, claimValue);
    return hasClaimValue;
  }
  const token = await getToken();
  if (!token) {
    return false;
  }
  try {
    const tokenObject = await verifyToken(token);
    return tokenObject[claimName] === claimValue || tokenObject[claimName].includes(claimValue);
  } catch (e) {
    return false;
  }
};

const getClientId = () => getCookies()[clientIdCookieName] || null;

const hasAdminClaim = async (token) => {
  if (!token) {
    return false;
  }
  try {
    const tokenObject = await verifyToken(token);
    return !!tokenObject[Claims.RxOrg];
  } catch (e) {
    return false;
  }
};

const getCurrentLoggedInParticipantId = async (token) => {
  if (!token) {
    return '';
  }
  try {
    const tokenObject = await verifyToken(token);
    return Claims.RxParticipant in tokenObject ? tokenObject[Claims.RxParticipant] : '';
  } catch (e) {
    return '';
  }
};

const getCurrentLoggedInRxOrgId = async (token) => {
  if (!token) {
    return '';
  }
  try {
    const tokenObject = await verifyToken(token);
    return Claims.RxOrg in tokenObject ? tokenObject[Claims.RxOrg] : '';
  } catch (e) {
    return '';
  }
};

export default {
  hasClaim,
  getToken,
  getClientId,
  hasAdminClaim,
  getCurrentLoggedInParticipantId,
  getCurrentLoggedInRxOrgId,
  verifyToken
};
